import VBottomNav from './VBottomNav'

export default {
  VBottomNav
}



// WEBPACK FOOTER //
// ./src/components/bottom-nav/index.js